import type { ReactNode } from 'react';

import { PermissionMetadata } from '@/utils';

import { usePermission } from '@/hooks';
import { Loading } from '@/components/common';

interface IPermissionGate {
  permissions: PermissionMetadata[];
  fallback?: ReactNode;
  children: ReactNode;
}

/**
 * Renders `children` only when the current user has the required permission.
 *
 *   <ProtectedComponent module={ModuleName} subModule={SubModuleName} action={ActionName}>
 *     <Button>Save</Button>
 *   </ProtectedComponent>
 */
export const ProtectedComponent = ({ permissions, fallback = null, children }: IPermissionGate) => {
  const { isGranted, isLoading } = usePermission();

  if (isLoading) return <Loading fullScreen />;
  return <>{permissions.some((permission) => isGranted(permission)) ? children : fallback}</>;
};
